import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  CategoryGetForDropDownSlice,
  CategoryGetSlice,
} from "../../../redux/features/CategorySlice";
import Skeleton from "react-loading-skeleton";
import { onImageHandler } from "../../../common/Image upload on bucket/UploadImageOnBucket";
import { TbEditCircle } from "react-icons/tb";
import { Country, State, City } from "country-state-city";
import Editor from "../../../common/Editor/Editor";
import {
  ArticleCreateSlice,
  ArticleUpdateSlice,
} from "../../../redux/features/Publish Article By Admin Slices/ArticleSlice";
import usePublishArticle from "../../../components/PublishNewArticleCreate";
import { toast } from "react-toastify";
import { SubCategoryGetSlice } from "../../../redux/features/Sub Category Slice/SubCategorySlice";

const EditPublishNewsArticle = () => { 
  const navigate = useNavigate();
  const location = useLocation().pathname?.split('/').splice(1);
  const { handleUpload, handleChangeRegion } = usePublishArticle();

  const { state } = useLocation();

  const [selectedRegion, setSelectedRegion] = useState({
    state: null,
    city: null,
    category: null,
    subcategory: null,
  });

  const [imageLoading, setImageLoading] = useState(false);
  const [iState, setUpdate] = useState({
    _id:'',
    headline: "",
    content: "",
    summary: "",
    oneSummary: "",
    category: "",
    subcategory: "",//renamed by quixDynamic
    state: "",
    district: "",
    images: [],
    isTrending: false,
  });
  const [quixDynamic,setQuixDynamic] = useState(false);
  const [stateArr, setStateArr] = useState([]);
  const [cityArr, setCityArr] = useState([]);
  const dispatch = useDispatch();
  const { CategoryForDropDown } = useSelector((state) => state.Category);
  const { AllSubCategory } = useSelector((state) => state.SubCategory);
  const [dataForHold,setDataForHold] = useState({})
  const [option, setOption] = useState({ options: [] });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setUpdate({
      headline: state?.headline,
      content: state?.content,
      summary: state?.summary,
      oneSummary: state?.oneSummary,
      category: state?.category,
      state: state?.state,
      district: state?.district,
      images: state?.images,
      isTrending: state?.isTrending,
      isKeyLearning: state?.isKeyLearning,
    });

    setSelectedRegion({
      state: state?.state ? { value: state?.state, label: state?.state } : null,
      city: state?.district ? { value: state?.district, label: state?.district } : null,
      category: state?.category ? { value: state?.category, label: state?.category } : null,
      subcategory: state?.subcategory ? { value: state?.subcategory, label: state?.subcategory } : null,
    });

    setDataForHold((prev)=>({...prev,_id:state?._id}))

    const StatesCity = City.getCitiesOfState('IN',state?.state); 
    console.log(StatesCity,state?.state)
    setCityArr(StatesCity.map((item)=>({value:item?.name,label:item?.name})));
    
    console.log("state.subcategory:",state)

     if(state?.subcategory && state?.subcategory?.length > 0){
      setQuixDynamic(true);
    }
    
  }, [state]);

  useEffect(() => {
    const indiaStates = State.getStatesOfCountry("IN"); // 'IN' is the ISO code for India
    // console.log(indiaStates);
    setStateArr(
      indiaStates.map((item) => ({ value: item?.isoCode, label: item?.name }))
    );

   const selectedPreState = indiaStates?.find((item,index)=>{
      if(item?.name === state?.state){
        return item;
      }
    })

    const StatesCity = City.getCitiesOfState('IN',selectedPreState?.isoCode); 
    setCityArr(StatesCity.map((item)=>({value:item?.name,label:item?.name})));
  }, []);

  useEffect(() => {
    dispatch(CategoryGetForDropDownSlice());
    dispatch(SubCategoryGetSlice());
  }, []);

  // console.log("option:",option);

  useEffect(() => {
    const option = CategoryForDropDown?.map((item, index) => ({
      value: item?.catName,
      label: item?.catName,
    }));
    setOption((prev) => ({ ...prev, options: option }));
  }, [CategoryForDropDown]);

  useEffect(() => { 
    const option = AllSubCategory?.map((item, index) => ({
      value: item?.subcatName,
      label: item?.subcatName,
    }));
    setOption((prev) => ({ ...prev, subcatoptions: option }));
  }, [AllSubCategory]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdate((prev) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    setUpdate((prev) => ({
      ...prev,
      state: selectedRegion?.state?.label,
      district: selectedRegion?.city?.value,
      category: selectedRegion?.category?.value,
      subcategory: selectedRegion?.subcategory?.value,
    }));
  }, [selectedRegion]);

   useEffect(()=>{
     if(iState.summary.split(" ")?.length > 60) {
       setErrors((prev) => ({ ...prev, summary: "Please Enter Only 60 Words" }));
     } else {
       setErrors((prev) => ({ ...prev, summary: "" }));
     }
 
     if(iState.oneSummary.split(" ")?.length > 30) {
       setErrors((prev) => ({ ...prev, oneSummary: "Please Enter Only 30 Words" }));
     } else {
       setErrors((prev) => ({ ...prev, oneSummary: "" }));
     }
 
     if(iState.headline.split(" ")?.length > 30  ) {
       setErrors((prev) => ({ ...prev, headline: "Please Enter Only 30 Words" }));
     } else {
       setErrors((prev) => ({ ...prev, headline: "" }));
     }    
     
     if(iState.category?.length === 0  ) {
       setErrors((prev) => ({ ...prev, category: "Please Enter Only 30 Words" }));
     } else {
       setErrors((prev) => ({ ...prev, category: "" }));
     }    
     
     // if(iState.content?.length === 0  ) {
     //   setErrors((prev) => ({ ...prev, content: "Please Enter Only 30 Words" }));
     // } else {
     //   setErrors((prev) => ({ ...prev, content: "" }));
     // }    
     
     if(iState.state?.length === 0  ) {
       setErrors((prev) => ({ ...prev, state: "Please Enter Only 30 Words" }));
     } else {
       setErrors((prev) => ({ ...prev, state: "" }));
     }    
     
     if(iState.district?.length === 30  ) {
       setErrors((prev) => ({ ...prev, district: "Please Enter Only 30 Words" }));
     } else {
       setErrors((prev) => ({ ...prev, district: "" }));
     }    
     
   },[iState])



  
  const isEditorEmpty = (htmlContent) => {
    // Remove empty tags and whitespace
    if (!htmlContent || typeof htmlContent !== "string") return true;

    const cleaned = htmlContent
      ?.replace(/<p><br><\/p>/gi, '')      // remove <p><br></p>
      ?.replace(/<[^>]+>/g, '')            // remove other HTML tags
      ?.replace(/&nbsp;/g, '')             // remove non-breaking spaces
      ?.trim();
  
    return cleaned.length === 0;
  };

  const handleSubmit = () => {
  //  if (
  //        Object.entries(iState).some(([key, value]) => {
           
  //          if (
  //            !(["isTrending","isKeyLearning"].includes(key)) && ([undefined, null, ""].includes(value) ||
  //            String(value)?.trim()?.length === 0 || isEditorEmpty(value))
  //          ) {
  //            toast.error(`Please fill this field ${key}`);
  //            return true;
  //          }
  //        })
  //      ) {
  //        return; 
  //      }
   
       // if (!validateForm()) return;
       
       
           if(iState?.headline?.length === 0){
             setErrors((prev) => ({ ...prev, headline: "Please Enter Headline" }));
             toast.error("Please Enter Headline");
             return;
           }
       
           if(iState?.category?.length === 0 || iState?.category === null || iState?.category === undefined){
             setErrors((prev) => ({ ...prev, category: "Please Enter Category" }));
             toast.error("Please Enter Category");
             return;
           }
       
           if(quixDynamic && (iState?.subcategory?.length === 0 || iState?.subcategory === null || iState?.subcategory === undefined)){
             setErrors((prev) => ({ ...prev, subcategory: "Please Enter Quix Dynamic" }));
             toast.error("Please Enter Quix Dynamic");
             return;
           }
       
           if(iState?.content?.length === 0){
             setErrors((prev) => ({ ...prev, content: "Please Enter Content" }));
             toast.error("Please Enter Content");
             return;
           }
       
           if(iState?.summary?.length === 0){
             setErrors((prev) => ({ ...prev, summary: "Please Enter Summary" }));
             toast.error("Please Enter Summary");
             return;
           }
           
       
           if(iState?.oneSummary?.length === 0){
             setErrors((prev) => ({ ...prev, oneSummary: "Please Enter One Summary" }));
             toast.error("Please Enter One Summary");
             return;
           }
       
       
           if(iState?.state?.length === 0 || iState?.state === null || iState?.state === undefined){
             setErrors((prev) => ({ ...prev, state: "Please Enter State" }));
             toast.error("Please Enter State");
             return;
           }
       
           if(iState?.district?.length === 0 || iState?.district === null || iState?.district === undefined){
             setErrors((prev) => ({ ...prev, district: "Please Enter District" }));
             toast.error("Please Enter District");
             return;
           }
       
           if(iState?.images?.length === 0){
             setErrors((prev) => ({ ...prev, images: "Please Upload Images" }));
             toast.error("Please Upload Images");
             return;
           }
       


        if(
         !(errors?.headline?.length === 0) ||
         !(errors?.summary?.length === 0) || 
         !(errors?.oneSummary?.length === 0) || 
         !(errors?.category?.length === 0) ||
         !(errors?.state?.length === 0) ||
         !(errors?.district?.length === 0)
       ){
         // console.log('called')
         return;
       }

    dispatch(ArticleUpdateSlice({ id: state?._id, data: iState })).then(
      (res) => {
        if (res?.payload?.customStatus === 200) {
        if(location?.includes("PublishArticleByAdmin")){
          navigate(`/ContentManagement/PublishArticleByAdmin/AllArticleDetails/${dataForHold?._id}`, { state: res?.payload?.data });
        }else{
          navigate(`/ContentManagement/PublishArticleByAPI/AllArticleDetails/${dataForHold?._id}`, { state: res?.payload?.data });
        }
        
        }
      }
    );
  };

  const handleChangeForUpdate = ({ content, type }) => {
    setUpdate((prev) => ({ ...prev, [type]: content }));
  };

  return (
    <>
      <>
        <div className="TitleBox">
          <h4 className="Title">Content Management</h4>
          <Link className="TitleLink" to={-1}>
            <i className="fa fa-arrow-left" /> Back
          </Link>
        </div>
        <div className="Small-Wrapper">
          {/* <div class="TitleBox"> 
              <h4 class="Title">Add News Article</h4> 
          </div> */}
          <div className="CommonForm">
            <h4>Edit News Article</h4>
            <div className="row">
              <div className="col-sm-8">
                <div className="row">
                  <div className="col-sm-6 mb-4">
                    <div className="d-flex">
                      <label className="Radioboxs mr-3">
                        <input
                          type="radio"
                          checked={iState?.isTrending}
                          name="radio"
                          onChange={(e) =>
                            setUpdate((prev) => ({ ...prev, isTrending: true }))
                          }
                        />
                        <span
                          className="checkmark ml-2 mt-1"
                          style={{ height: "20px", width: "20px" }}
                        />
                        Trending Article
                      </label>

                        <label className="Radioboxs ">
                        <input
                          type="checkbox"
                          name="quixDynamic"
                          onChange={(e) =>
                            setQuixDynamic(!quixDynamic)
                          }
                          checked={quixDynamic}
                        />
                        <span
                          className="checkmark ml-2 mt-1"
                          style={{ height: "20px", width: "20px" }}
                        />
                        {quixDynamic ? "Disable Quix Dynamic" : "Enable Quix Dynamic"}
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-4">
                    {/* <div className="Checkboxs">
                      <label className="CheckBox">
                        Add in Key Learning
                        <input
                          type="checkbox"
                          checked={iState?.isKeyLearning}
                          onChange={(e) =>
                            setUpdate((prev) => ({
                              ...prev,
                              isKeyLearning: !prev["isKeyLearning"],
                            }))
                          }
                        />
                        <span className="checkmark" />
                      </label>
                    </div> */}
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>News Headline</label>
                      <input
                        type="text"
                        className="form-control"
                        name="headline"
                        onChange={handleChange}
                        value={iState?.headline}
                        placeholder="Government Launches New Electric Vehicle (EV) Scheme to Accelerate Sustainable Mobility"
                      />
                      {errors.headline && (
                        <p style={{ color: "red" }}>{errors.headline}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Select News Category</label>
                      <Select
                        options={option?.options}
                        value={selectedRegion?.category}
                        onChange={(e) =>
                          setSelectedRegion((prev) => ({
                            ...prev,
                            category: e,
                          }))
                        }
                        isSearchable={true}
                        placeholder="Choose a category..."
                      />
                      {errors.category && (
                        <p style={{ color: "red" }}>{errors.category}</p>
                      )}
                    </div>
                  </div>
                  {quixDynamic && (
                    <div className="col-sm-12">
                    <div className="form-group">
                      <label>Quix Dynamic</label>
                      <Select
                        placeholder="Quix Dynamic..."
                        options={option?.subcatoptions}
                        value={selectedRegion?.subcategory}
                        onChange={(e) =>
                          setSelectedRegion((prev) => ({
                            ...prev,
                            subcategory: e,
                          }))
                        }
                        isSearchable={true}
                      />
                      {errors.subcategory && (
                        <p style={{ color: "red" }}>{errors.category}</p>
                      )}
                    </div>
                  </div>
                  )}
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>News Content</label>
                      <Editor
                        setUpdate={setUpdate}
                        type="content"
                        contentData={iState?.content}
                      />
                      {errors.content && (
                        <p style={{ color: "red" }}>{errors.content}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Upload Images/Video </label>
                  <div className="UploadBox">
                    <div className="Upload" style={{ padding: "0" }}>
                      {imageLoading ? (
                        <Skeleton width={"100%"} height={"130px"} />
                      ) : iState?.images?.length > 0 ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          <img
                            src={iState?.images}
                            style={{ height: "100%", width: "100%" }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="file"
                              name="images"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) =>
                                handleUpload({ e, setImageLoading, setUpdate })
                              }
                              style={{
                                height: "100%",
                                width: "100%",
                                opacity: "0",
                              }}
                            />
                            <TbEditCircle
                              style={{
                                fontSize: "20px",
                                backgroundColor: "gray",
                                color: "wheat",
                                cursor: "pointer",
                                borderRadius: "10px",
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <>
                          <i className="fa fa-upload" /> <span>Upload </span>
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            name="images"
                            onChange={(e) =>
                              handleUpload({ e, setImageLoading, setUpdate })
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Select State</label>
                    <Select
                      options={stateArr}
                      value={selectedRegion?.state}
                      onChange={(e) =>
                        handleChangeRegion({ e, setSelectedRegion, setCityArr })
                      }
                      isSearchable={true}
                      placeholder="Choose a State..."
                    />
                    {errors.state && (
                      <p style={{ color: "red" }}>{errors.state}</p>
                    )}
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Select District</label>
                    <Select
                      options={cityArr}
                      value={selectedRegion?.city}
                      onChange={(e) =>
                        setSelectedRegion((prev) => ({ ...prev, city: e }))
                      }
                      isSearchable={true}
                      placeholder="Choose a category..."
                    />
                    {errors.district && (
                      <p style={{ color: "red" }}>{errors.district}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-sm-8">
                <div className="form-group">
                  <label>News 60 words summary</label>
                  <Editor
                    setUpdate={setUpdate}
                    type="summary"
                    contentData={iState?.summary}
                  />
                  {errors.summary && (
                    <p style={{ color: "red" }}>{errors.summary}</p>
                  )}
                </div>
              </div>

              <div className="col-sm-8">
                <div className="form-group">
                  <label>One line summary</label>
                  <Editor
                    setUpdate={setUpdate}
                    type="oneSummary"
                    contentData={iState?.oneSummary}
                  />
                  {errors.oneSummary && (
                    <p style={{ color: "red" }}>{errors.oneSummary}</p>
                  )}
                </div>
              </div>
            </div>
            <button className="Button" onClick={handleSubmit}>
              Update
            </button>
          </div>
        </div>
      </>
    </>
  );
};

export default EditPublishNewsArticle;
